import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Eye, EyeOff, KeyRound, Lock, LockKeyhole, LucideAngularModule, Mail } from "lucide-angular";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { ResetPasswordFormComponent } from "./reset-password-form.component";

@NgModule({
  declarations: [ResetPasswordFormComponent],
  imports: [
    CommonModule,
    CommonTranslateModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    LucideAngularModule.pick({ Mail, KeyRound, Lock, LockKeyhole, Eye, EyeOff }),
  ],
  exports: [ResetPasswordFormComponent],
})
export class ResetPasswordFormModule {}
